export default __webpack_public_path__ + "static/media/logo_Cn.f909fb4f.png";